import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchPlanscreate } from '../api/plan';
import { getCoupons } from '../api/coupon';
import RegistarLayout from '../components/RegistarLayout';
import InputFormLayout from '../components/InputFormLayout';
import RegistarButtonLayout from '../components/RegistarButtonLayout';
import SelectLayout from '../components/SelectLayout';
import './PlanRegistar.css';

export default function PlanCreate() {
  const [name, setName] = useState('');
  const [amount, setAmount] = useState('');
  const [planType, setPlanType] = useState('premium');
  const [interval, setInterval] = useState('one_time');
  const [trialDays, setTrialDays] = useState(0);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { companyId } = useParams();
  const [coupons, setCoupons] = useState([]);
  const [selectedCoupon, setSelectedCoupon] = useState('');
  const [isAutoCouponPrefill, setIsAutoCouponPrefill] = useState(false);

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const res = await getCoupons();
        setCoupons(res.coupons || []);
      } catch (err) {
        console.error(err);
        setError('クーポン情報の取得に失敗しました');
      }
    };
    fetchCoupons();
  }, []);

  useEffect(() => {
    if (!selectedCoupon) {
      setIsAutoCouponPrefill(false);
    }
  }, [selectedCoupon]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const payload = {
        company_id: companyId,
        name,
        amount: parseInt(amount),
        plan_type: planType,
        interval,
        trial_days: interval === 'month' ? parseInt(trialDays) : 0,
        promotion_code: selectedCoupon || null,
        is_auto_coupon_prefill: isAutoCouponPrefill,
      };

      await fetchPlanscreate(payload);

      setMessage('プランを登録しました！');
      setName('');
      setAmount('');
      setPlanType('premium');
      setInterval('one_time');
      setTrialDays(0);
      setSelectedCoupon('');
      setIsAutoCouponPrefill(false);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'プラン登録に失敗しました');
    }
  };

  return (
    <RegistarLayout title="プラン作成" margin="0 auto" marginTop="15vh">
      {message && <div style={{ color: 'green' }}>{message}</div>}
      {error && <div style={{ color: 'red' }}>{error}</div>}

      <div className="planElement">
        <InputFormLayout
          id="planName"
          labelTitle="プラン名"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder=""
        />

        <InputFormLayout
          id="amount"
          labelTitle="金額（円）"
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder=""
        />

        <SelectLayout
          id="coupon"
          selectTitle="クーポン"
          value={selectedCoupon}
          onChange={(e) => setSelectedCoupon(e.target.value)}
          options={coupons?.map((coupon) => ({
            id: coupon.id,
            name: coupon.name,
            value: coupon.promotion_code_id,
          }))}
        />

        {selectedCoupon && (
          <SelectLayout
            id="is_auto_coupon_prefill"
            selectTitle="クーポン自動フィルイン"
            value={isAutoCouponPrefill ? '1' : '0'}
            onChange={(e) => setIsAutoCouponPrefill(e.target.value === '1')}
            options={[
              { id: 'prefill_off', name: 'しない', value: '0' },
              { id: 'prefill_on', name: 'する', value: '1' },
            ]}
            show={false}
            required={false}
          />
        )}

        <SelectLayout
          id="interval"
          selectTitle="課金タイプ"
          value={interval}
          onChange={(e) => setInterval(e.target.value)}
          options={[
            { value: 'one_time', name: '一括払い' },
            { value: 'month', name: 'サブスクリプション' },
          ]}
          show={false}
        />

        {interval === 'month' && (
          <InputFormLayout
            id="trialDays"
            labelTitle="無料トライアル日数"
            type="number"
            value={trialDays}
            onChange={(e) => setTrialDays(e.target.value)}
            min="0"
          />
        )}

        <div className="planRegisterButtons">
          <RegistarButtonLayout
            buttonTitle="登録"
            type="submit"
            onClick={handleSubmit}
          />
          <RegistarButtonLayout
            buttonTitle="企業一覧に戻る"
            type="button"
            onClick={() => navigate('/campaignlist')}
          />
          <RegistarButtonLayout
            buttonTitle="企業ポータルに戻る"
            type="button"
            onClick={() => navigate('/implpage')}
          />
        </div>
      </div>
    </RegistarLayout>
  );
}
